import {Component, HostListener, Inject, OnInit} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {Router} from '@angular/router';
import {AppUser, AppUserData} from './framework/AppUser';
import {AppRoutingModule} from './app-routing.module';
import {PagesModuleRouting} from './pages/pages.module';
import {environment} from '../environments/environment';
import {OKTA_AUTH} from '@okta/okta-angular';
import {OktaAuth} from '@okta/okta-auth-js';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	providers: [AppUser]
})
export class AppComponent implements OnInit {

	public loginData: AppUserData = new AppUserData();
	public interval;
	public appNeedUpdate = false;

	constructor(public sanitizer: DomSanitizer, public router: Router, public user: AppUser, @Inject(OKTA_AUTH) public oktaAuth: OktaAuth) {

		if (window && window['EnvConfig'] && window['EnvConfig']['APP_VERSION']) {
			const lastCurrentVersion = window.localStorage.getItem('APP_VERSION');
			console.log('lastCurrentVersion', lastCurrentVersion, window['EnvConfig']['APP_VERSION']);
			if (!lastCurrentVersion || lastCurrentVersion !== window['EnvConfig']['APP_VERSION']) {
				this.appNeedUpdate = true;
			}
			window.localStorage.setItem('APP_VERSION', window['EnvConfig']['APP_VERSION']);

		}
	}

	updateAppToLatestVersion() {
		document.location.replace(document.location.href + (document.location.href.indexOf('?') === -1 ? '?' : '&') + 'time=' + new Date().getTime());
	}

	public debugChangeToken() {

		const gs = [];
		const gsReal = [];
		for (const g in this.debug.rolesSelected) {
			if (this.debug.rolesSelected[g]) {
				gs.push(g);
				gsReal.push('QARSOD_' + g);
			}
		}

		AppUser.data.token = '@' + this.debug.username + ':' + gsReal.join(',');
		AppUser.data.groups = gs;
		AppUser.data.login = this.debug.username;
		this.loginData.login = this.debug.username;
		this.loginData.groups = gs;
		this.hideUserOverrideModal = true;
		console.log(AppUser.data);
		this.router.navigateByUrl('/');
		this.menu_init();
		console.log('debugChangeToken', this.debug, gs);
	}

	public debug = {
		username: '',
		rolesSelected: [],
		roles: [
			'ADMINS',
			'APPROVERS',
			'SUPER_APPROVERS',
			'AUDITORS',
			'HELPDESKS',
			'REVIEWERS',
			'REPORT_REASSIGNERS'
		],
		active: false,
		isLocal: false
	};
	public hideUserOverrideModal = true;

	public formatGroupeName(gname) {
		return gname.replace('qarsod_', '').replace('_', ' ');
	}

	ngOnInit() {
		this.interval = setInterval(() => {
			if (AppUser.data.login != null) {
				Object.assign(this.loginData, AppUser.data);
				this.debug.username = this.loginData.login;
				if (this.loginData.groups.length) {
					for (const g of this.loginData.groups) {
						this.debug.rolesSelected[g] = true;
					}
				}

				this.debug.active = environment.name === 'dev' || environment.name === 'test';
				this.debug.isLocal = environment.name === 'local';
				this.menu_init();
				clearInterval(this.interval);
			}
		}, 1000);
	}


	async logout() {
		// Terminates the session with Okta and removes current tokens.
		this.deleteAllCookies();
		window.localStorage.clear();
		window.sessionStorage.clear();
		this.oktaAuth.tokenManager.clear();
		await this.oktaAuth.signOut();
		window.location.replace('/');
	}

	deleteAllCookies() {
		const cookies = document.cookie.split(';');

		for (let i = 0; i < cookies.length; i++) {
			const cookie = cookies[i];
			const eqPos = cookie.indexOf('=');
			const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
			document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
		}
	}

	menu_init() {
		const routes = PagesModuleRouting.routes;
		const urlToRight = {};
		for (const r of routes) {
			urlToRight[r.path ? 'p/' + r.path : ''] = r.data?.right;
		}
		// console.log(urlToRight);

		for (const m of this.menu) {
			let atLeastOne = false;
			for (const k of m.kids) {
				// console.log(k);
				const rights = urlToRight[k.url];
				//const allowed = rights && this.user.isAllowed(rights);
				// console.log({url: k.url, rights, allowed});
				this.menuAllowed[k.url] = true;

				//if (allowed) {
					atLeastOne = true;
				//}
			}
			this.menuAllowed[m.name] = atLeastOne;
		}
	}

	public menuAllowed = {};

	public menu = [
		{
			name: 'Reports', kids: [
				{url: '', name: 'Home'},
				{url: 'p/reports', name: 'QAR Browser'},
				{url: 'p/reports/system-access', name: 'System Access Report'},
				{url: 'p/reports/rejected-users', name: 'Rejected Users'},
				{url: 'p/approval-requests', name: 'Approval Requests'}
			]
		},
		{
			name: 'Admin', kids: [
				{url: 'p/tools/anomalies', name: 'Anomalies'},
				{url: 'p/tools/sod-checker', name: 'SOD Clash Checker'},
				{url: 'p/tools/sod-clashes', name: 'SOD Clashes'},
				{url: 'p/tools/approvers-access-check', name: 'Users Access'},
				{url: 'p/reports/chasing', name: 'Chasing'},
				{url: 'p/audit/logs', name: 'Audit Logs'},
				{url: 'p/users', name: 'User Roles Checker'},
				{url: 'p/tools/user-roles-auto-rec', name: 'User Roles Auto Reconciliation'},
				{url: 'p/reports/inactive-users', name: 'Users inactive (in AD)'}
			]
		},
		{
			name: 'Config', kids: [
				{url: 'p/config', name: 'Settings'},
				{url: 'p/config/systems', name: 'Current Source Systems'},
				{url: 'p/config/sor-user-mappings', name: 'Local User Aliases'},
				{url: 'p/config/sod-roles', name: 'System Roles & SOD'},
				{url: 'p/config/blacklist', name: 'User & Role Blacklist'},
				{url: 'p/config/approver-overrides', name: 'Approver Overrides'},
				{url: 'p/tools/reassign-reports', name: 'Reassign Reports'},

			]
		}
	];
}
